import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogOverlay,
} from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TujuanDialogProps = Omit<DialogProps, 'children'> & {
  title: string
  suggestion?: string
  content: Array<{ title: string; description: string }>
  onConfirm?: () => void
}

export function TujuanDialog({
  content,
  suggestion,
  title,
  onConfirm = () => {},
  ...dialogProps
}: TujuanDialogProps) {
  return (
    <Dialog size="md" {...dialogProps}>
      <DialogOverlay />
      <DialogContent>
        <DialogHeader title={title} />

        <div className="p-6 flex flex-col space-y-4">
          <Text variant="heading-sm">Tujuan:</Text>

          <div className="border border-disabled rounded">
            {content.map(({ title, description }, i) => (
              <div
                key={i}
                className="p-3 border-b border-disabled last:border-0"
              >
                <Text>{title}</Text>
                <Text variant="body-sm" color="subdued">
                  {description}
                </Text>
              </div>
            ))}
          </div>

          {suggestion && (
            <div className="p-4 flex flex-row bg-cyan-5 rounded">
              <Text variant="body-bold">Kami sarankan untuk:&nbsp;</Text>
              <Text>{suggestion}</Text>
            </div>
          )}
          <div className="flex justify-center items-center">
            <Button
              onClick={() => {
                onConfirm()
                dialogProps?.onClose?.()
              }}
            >
              Saya mengerti
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
